var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "modal fade",
      attrs: { id: "require-use-warehouse-modal", role: "dialog" },
      on: {
        click: function($event) {
          _vm.$emit("close")
        }
      }
    },
    [
      _c(
        "div",
        {
          staticClass: "modal-dialog modal-lg",
          on: {
            click: function($event) {
              $event.stopPropagation()
            }
          }
        },
        [
          _c("div", { staticClass: "modal-dialog modal-lg" }, [
            _c(
              "div",
              {
                staticClass: "modal-content additonal-modal-content bd-rds-16"
              },
              [
                _c("div", { staticClass: "pd-t-20 pd-b-20 pd-l-5 pd-r-5" }, [
                  _c(
                    "div",
                    {
                      staticClass:
                        "flex flex-flow-column flex-content-center font-bold text-size-20 pd-l-100 pd-r-100 text-plan-normal gap-10"
                    },
                    [
                      _vm._m(0),
                      _vm._v(" "),
                      _c(
                        "button",
                        {
                          staticClass:
                            "btn btn-warning btn-shadow btn-upgrade-plan bd-rds-8 text-size-22 pd-t-20 pd-b-15 pd-r-100 pd-l-100 mr-t-10",
                          on: {
                            click: function($event) {
                              _vm.$emit("close")
                              _vm.$router.push("/warehouses")
                            }
                          }
                        },
                        [
                          _vm._v(
                            "\n              倉庫管理画面はこちら\n              "
                          ),
                          _c("i", {
                            staticClass: "fa fa-arrow-circle-right fa-lg",
                            attrs: { "aria-hidden": "true" }
                          })
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "a",
                        {
                          staticClass: "text-size-14 mr-t-20",
                          on: {
                            click: function($event) {
                              _vm.$emit("close")
                            }
                          }
                        },
                        [_vm._v("閉じる")]
                      )
                    ]
                  )
                ])
              ]
            )
          ])
        ]
      )
    ]
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "text-size-24" }, [
      _vm._v("\n              STOCKCREW倉庫をご利用いただくためには、"),
      _c("br"),
      _vm._v("\n              倉庫管理画面より\n              "),
      _c("span", { staticClass: "text-dark-red" }, [
        _vm._v("STOCKCREW倉庫を追加")
      ]),
      _vm._v("\n              していただくようにお願いします。\n            ")
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-e1bb5552", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e1bb5552","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/view/warehouseAcross/components/RequireUseScWarehouseModal.vue
// module id = null
// module chunks = 